import * as Yup from 'yup'
import emailValidator from 'utils/validators/emailValidator'

export const validationSchema = Yup.object().shape({
  email: Yup.string()
    .test(
      'emailValidator',
      'common::validation_messages.incorrect_email_format',
      emailValidator,
    )
    .required('common::validation_messages.required'),
  password: Yup.string().required('common::validation_messages.required'),
})
